// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-hardtail-js": () => import("./../../../src/pages/hardtail.js" /* webpackChunkName: "component---src-pages-hardtail-js" */),
  "component---src-pages-hardtail-strapi-bikes-title-js": () => import("./../../../src/pages/hardtail/{StrapiBikes.title}.js" /* webpackChunkName: "component---src-pages-hardtail-strapi-bikes-title-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-strapi-bikes-title-js": () => import("./../../../src/pages/{StrapiBikes.title}.js" /* webpackChunkName: "component---src-pages-strapi-bikes-title-js" */)
}

